import {
	applyFloorPlanFilter,
	focusFloorPlan,
	openFloorPlanSection,
} from './adapter';
import {
	openFloorPlanConfigureModal,
	openFloorPlanCreateModal,
	openFloorPlanDeleteModal,
	openFloorPlanPreviewModal,
} from './modal';
import {resolveFloorPlans} from './resolver';

/**
 * Floor Plans.
 *
 * The list on a Site's dashboard: a drawing of a floor, its size, and the
 * Access Points and Switches placed on it. A record collection in its own
 * right - the accordion has a search box and an Add button, and every row
 * offers Configure, Preview and Delete.
 *
 * Scoped to one Site, which is the difference from the IO-Pass lists: a
 * floor plan belongs to a Site and the request has to settle which one
 * before any of this can run.
 *
 * Every action ends at a Canvas form, a preview or a confirmation. Configure
 * opens the editor and stops: placing devices on the drawing is the person's.
 */
const floorPlanPlugin = {
	id: 'floor_plan',
	version: 1,
	commandVersion: 1,
	resource: 'floor_plan',
	operations: [
		'options',
		'view',
		'search',
		'create',
		'configure',
		'preview',
		'delete',
		'bulk_delete',
	],
	dependencies: {
		plugins: ['canvas.navigation', 'site'],
		destinations: ['site.dashboard'],
	},
	sections: {
		'site.floor_plans': openFloorPlanSection,
	},
	resolvers: {
		floor_plan: resolveFloorPlans,
	},
	filters: {
		floor_plan: applyFloorPlanFilter,
	},
	focusHandlers: {
		floor_plan: focusFloorPlan,
	},
	modals: {
		'floor_plan.create': openFloorPlanCreateModal,
		'floor_plan.configure': openFloorPlanConfigureModal,
		'floor_plan.preview': openFloorPlanPreviewModal,
		'floor_plan.delete': openFloorPlanDeleteModal,
	},
};

export default floorPlanPlugin;
